import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { RollNumberConfigService } from '../../../services/roll-number-config.service';

@Component({
  selector: 'app-delete-roll-number',
  imports: [SharedModule],
  templateUrl: './delete-roll-number.component.html',
  styleUrl: './delete-roll-number.component.scss'
})
export class DeleteRollNumberComponent {
  @Input() rollNumberConfigData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  btnLoading = false;

  constructor(
    private messageService: MessageService,
    private api: RollNumberConfigService
  ) { }

  onDelete() {
    this.btnLoading = true;

    const deleteData = {
      roll_number_config_id: this.rollNumberConfigData.roll_number_config_id
    };

    this.api.deleteRollNumberConfig(deleteData).subscribe({
      next: (res: any) => {
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: 'Roll number configuration deleted successfully.' 
        });
        this.btnLoading = false;
        this.closeDialog.emit();
        this.reload.emit();
      },
      error: (error: any) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: error?.error?.message || 'Failed to delete roll number configuration.' 
        });
        this.btnLoading = false;
      }
    });
  }

  onCancel() {
    this.closeDialog.emit();
  }
}
